// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import 'lib-flexible';

import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(Vuex)

Vue.config.productionTip = false

// 多语言配置
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

import LangCN from './lang/i18nCN'
import LangEN from './lang/i18nEN'
import LangJP from './lang/i18nJP'
import LangKR from './lang/i18nKR'
import LangHANT from './lang/i18nHANT'

const i18n = new VueI18n({
    locale: 'cn',
    messages: {
        'cn': LangCN,
        'hant': LangHANT,
        'en': LangEN,
        'jp': LangJP,
        'kr': LangKR
    },
    silentTranslationWarn: true,
});

const Util = require('./lib/utils')
Util.setCookie('lang', i18n.locale)

/* eslint-disable no-new */
window.ROOT_APP = new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js